import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-585b2a8f")

_pushScopeId("data-v-585b2a8f")
const _hoisted_1 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DefaultSkeleton = _resolveComponent("DefaultSkeleton")

  return (_openBlock(), _createBlock(_Transition, {
    name: "fade-in",
    appear: ""
  }, {
    default: _withId(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock("div", _mergeProps({ key: 0 }, _ctx.$attrs), [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 16))
        : (_openBlock(), _createBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "holder", {}, () => [
              _createVNode("div", {
                class: ["skl", _ctx.holderClass]
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.skeletonRepeat, (i) => {
                  return (_openBlock(), _createBlock(_component_DefaultSkeleton, { key: i }))
                }), 128))
              ], 2)
            ], {}, true)
          ]))
    ]),
    _: 3
  }))
})